import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import HairPage from "./HairPage";
import FoodPage from "./FoodPage";
import VitaminPage from "./VitaminPage";
import foodProductsData from "../food_products.json";
import hairProductsData from "../hair_products.json";

const ProductPage = () => {
  const { barcodeOrId } = useParams();
  const [product, setProduct] = useState(null);
  const [productType, setProductType] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!barcodeOrId) return;
    const hairProducts = Object.entries(hairProductsData).flatMap(([group, products]) =>
      products.map(product => ({ ...product, groupCategory: group }))
    );
    const foodProducts = Object.entries(foodProductsData).flatMap(([group, products]) =>
      products.map(product => ({ ...product, groupCategory: group }))
    );
    let foundProduct = null;
    let type = null;
    if (barcodeOrId.startsWith("id-")) {
      const cleanId = barcodeOrId.replace("id-", "");
      const foundInHair = hairProducts.find(item => String(item.id) === cleanId);
      const foundInFood = foodProducts.find(item => String(item.id) === cleanId);
      if (foundInHair) {
        foundProduct = foundInHair;
        type = "hair";
      } else if (foundInFood) {
        foundProduct = foundInFood;
        type = "food";
      }
    } else {
      const foundInHair = hairProducts.find(item => item.barcode === barcodeOrId);
      const foundInFood = foodProducts.find(item => item.barcode === barcodeOrId);
      if (foundInHair) {
        foundProduct = foundInHair;
        type = "hair";
      } else if (foundInFood) {
        foundProduct = foundInFood;
        type = "food";
      }
    }
    setProduct(foundProduct);
    setProductType(type);
    setLoading(false);
  }, [barcodeOrId]);

  if (loading) {
    return <div>Loading...</div>;
  }
  if (!product) {
    return <div>Product not found.</div>;
  }
  
  if (product.groupCategory === "Vitamin ve Sağlık") {
    return <VitaminPage product={product} />;
  }
  
  return productType === "food" ? <FoodPage product={product} /> : <HairPage product={product} />;
};

export default ProductPage;
